import { render, staticRenderFns } from "./NextQueueNumber.vue?vue&type=template&id=7533b4a9&"
import script from "./NextQueueNumber.vue?vue&type=script&lang=js&"
export * from "./NextQueueNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports